import React, {forwardRef, useState} from 'react';
import BaseSimpleItemBrowser from "../BaseSimplePage/BaseSimpleItemBrowser";
import {getShortName} from "../../utils/PersonNameUtil";
import LiteraryWorksItemBrowserHeader from "./LiteraryWorksItemBrowserHeader";

const LiteraryWorksItemBrowser = forwardRef(({
                                                  ...restProps
                                              }, ref) => {

    const [authorId, setAuthorId] = useState(0);
    const [filterExtraParams, setFilterExtraParams] = useState({});

    function getItemSubtitle(item) {
        if (item.author_id === null)
            return "(без автора)";

        const authorItem = restProps.refsData?.authors?.[item.author_id];
        return authorItem ? getShortName(authorItem.first_name, authorItem.last_name, authorItem.middle_name) : "?";
    }

    function renderHeader(headerProps) {
        return <LiteraryWorksItemBrowserHeader
            {...headerProps}
            authorId={authorId}
            setAuthorId={handleAuthorIdChange}
        />
    }

    function handleAuthorIdChange(value) {
        const newFilterExtraParams = {...filterExtraParams};
        if (value === 0) {
            delete newFilterExtraParams.author_id;
            delete newFilterExtraParams.authorless;
        }
        else if (value === -1) {
            delete newFilterExtraParams.author_id;
            newFilterExtraParams.authorless = true;
        }
        else {
            newFilterExtraParams.author_id = value;
            delete newFilterExtraParams.authorless;
        }

        setAuthorId(value);
        setFilterExtraParams(newFilterExtraParams);
        ref.current.onFilterEdit(true);
    }

    return (
        <BaseSimpleItemBrowser
            {...restProps}
            ref={ref}
            getItemSubtitleFunc={getItemSubtitle}
            renderHeaderFunc={renderHeader}
            filterExtraParams={filterExtraParams}
        />
    );
});

export default LiteraryWorksItemBrowser;